import Requester from "./Requester";

export type CompareProduct = {
    id: number;
    name: string;
    sku: string;
    alias: string;
    brand?: { id: number; name: string } | null;
    image?: string | null;
    min_price?: number | null; // cents
    offers?: number;
};

export type CompareColumn = {
    attribute_id: number;
    attribute_name: string;
    coverage: number;
};

export type CompareMatrix = Record<number, Record<number, string | null | undefined>>;

export type ComparisonResponse = {
    products: CompareProduct[];
    columns: CompareColumn[];
    matrix: CompareMatrix;
};

type Options = { signal?: AbortSignal };

export function getComparison(ids: number[], options: Options = {}) {
    const requester = new Requester();
    const qs = [{ name: "ids", value: ids.join(",") }];
    return requester.get(
        requester.getUrl("api/frontend/compare", qs),
        { signal: options.signal }
    ) as Promise<ComparisonResponse>;
}

export function formatCents(cents?: number | null, currency = "CAD") {
    if (typeof cents !== "number" || Number.isNaN(cents)) return "—";
    return new Intl.NumberFormat(undefined, { style: "currency", currency }).format(cents / 100);
}